import React, { useEffect, useState, useCallback } from 'react';
import { Input, Tag } from 'antd4';
import op from 'object-path';

import './Fields.scss';
import AuditLog from '../../../components/AuditLog';

const { TextArea } = Input;

const Field = ({
  path,
  width,
  label,
  editable,
  disabled,
  minRows,
  maxRows,
  data,
  audit = [],
  updateField
}) => {
  let dataValue = op.get(data, path);
  const [value, setValue] = useState(dataValue);
  const [isDirty, setDirty] = useState(false);

  useEffect(
    value => {
      const updateValue = op.get(data, path);
      setValue(updateValue);
    },
    [data, path]
  );

  const myAudit = React.useMemo(
    () => audit?.filter(item => item?.path === path),
    [audit, path]
  );

  const [statusClass, setStatusClass] = useState('');
  const onSave = useCallback(
    async event => {
      const value = event?.target?.value;
      if (isDirty) {
        const response = await updateField(path, value);
        if (response?.ok) {
          // console.log('response ok, setting dirty to FALSE. adding save-success' );
          setDirty(false);
          setStatusClass('save-success');

          setTimeout(() => {
            setStatusClass('');
          }, 3000);
        } else {
          setStatusClass('save-error');
        }
      } else {
        // console.log('not dirty');
      }
    },
    [isDirty, updateField, path]
  );

  return (
    <div
      key={path}
      className={`input-container d-flex flex-col justify-content-start align-items-start w-${width ??
        '25'}`}
    >
      <Tag className="input-prefix border-radius flex-shrink-0 mr-0 mb-1 flex items-center">
        {label ?? ''}
        {!disabled && editable && (
          <AuditLog
            audits={myAudit}
            label={<>Histórico{label ? ` - ${label}` : ``}</>}
          ></AuditLog>
        )}
      </Tag>
      <TextArea
        className={'input ' + statusClass}
        value={value}
        autoSize={{
          minRows: minRows ?? 2,
          maxRows: maxRows ?? undefined
        }}
        disabled={disabled}
        onBlur={event => {
          if (editable === false) {
            event.preventDefault();
            return null;
          }
          onSave(event);
        }}
        onPressEnter={event => {
          if (editable === false) {
            event.preventDefault();
            return null;
          }
          onSave(event);
        }}
        onChange={event => {
          // console.log('SETTING dirty and value');
          if (editable === false) {
            event.preventDefault();
            return null;
          }
          setDirty(true);
          setValue(event.target.value);
        }}
      />
    </div>
  );
};

export default Field;
